import { Container } from "./styles";
import { IProposta } from "../../../../utility/IProposta";
import { FlexSimplesInfoPrincipal } from "../../Common/styles";
import BlocoAudiencia from "./BlocoAudiencia";
import BlocoValores from "./BlocoValores";
import BlocoCronograma from "./BlocoCronograma";
import BlocoPartes from "./BlocoPartes";
import { useMemo } from "react";
import { isStatusOndePrazoAceiteNaoEditavel } from "../../../../hooks/useEdicaoDemanda";

interface InfoPrincipalProps {
    demanda?: IProposta | null;
    loading: boolean;
    isEditing?: boolean;
    isSaving?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
    onRecarregarDemanda?: () => void;
    camposEditaveisRestritos?: boolean;
}

export default function InfoPrincipal({demanda, loading, isEditing, isSaving = false, onChange, onBlur, errors, onRecarregarDemanda, camposEditaveisRestritos = false}: InfoPrincipalProps) {

    const ehAudiencia = useMemo(() => demanda?.descricao_categoria_servico === 'Audiências', [demanda]);
    const isDisabled = isSaving || (isEditing && loading);

    const prazoAceiteNaoEditavel = useMemo(() => {
        return isStatusOndePrazoAceiteNaoEditavel(demanda);
    }, [demanda]);

    const isDisabledPrazoAceite = useMemo(() => {
        return isDisabled || (isEditing && prazoAceiteNaoEditavel);
    }, [isDisabled, isEditing, prazoAceiteNaoEditavel]);

    const isEditingAudiencia = camposEditaveisRestritos ? false : isEditing;
    const isEditingCronograma = camposEditaveisRestritos ? false : isEditing;
    const isEditingPartes = camposEditaveisRestritos ? false : isEditing;
    const isEditingValores = isEditing;

    return (
        <Container>
            <FlexSimplesInfoPrincipal>
                {
                    ehAudiencia &&
                    <BlocoAudiencia demanda={demanda} loading={loading} isEditing={isEditingAudiencia} isDisabled={isDisabled} onChange={onChange} onBlur={onBlur} errors={errors} />
                }
                <BlocoValores demanda={demanda} loading={loading} ehAudiencia={ehAudiencia} isEditing={isEditingValores} isDisabled={isDisabled} onChange={onChange} onBlur={onBlur} errors={errors} />
            </FlexSimplesInfoPrincipal>
            <BlocoCronograma demanda={demanda} loading={loading} isEditing={isEditingCronograma} isDisabled={isDisabled} isDisabledPrazoAceite={isDisabledPrazoAceite} onChange={onChange} onBlur={onBlur} errors={errors} />
            <BlocoPartes 
                demanda={demanda} 
                loading={loading} 
                isEditing={isEditingPartes} 
                isDisabled={isDisabled}
                onChange={onChange}
                onBlur={onBlur}
                errors={errors}
                onPartesChange={(partes) => onChange?.('partes_processo', partes)}
                onPartesRepresentadasChange={(partes) => onChange?.('partes_representadas', partes)}
                onRecarregarDemanda={onRecarregarDemanda}
            />
        </Container>
    )
}